import React from "react";

const origin = "https://observertheory.com";

const upsertMeta = (selector: string, attributes: Record<string, string>) => {
  let node = document.head.querySelector<HTMLMetaElement>(selector);
  if (!node) {
    node = document.createElement("meta");
    document.head.appendChild(node);
  }
  Object.entries(attributes).forEach(([key, value]) =>
    node!.setAttribute(key, value),
  );
};

export default function SeoHead({
  title,
  description,
  path,
  noIndex = false,
  jsonLd,
}: {
  title: string;
  description: string;
  path: string;
  noIndex?: boolean;
  jsonLd?: object;
}) {
  React.useEffect(() => {
    const canonicalURL = origin + path;
    document.title = title;
    upsertMeta('meta[name="description"]', {
      name: "description",
      content: description,
    });
    upsertMeta('meta[name="robots"]', {
      name: "robots",
      content: noIndex ? "noindex,follow" : "index,follow",
    });
    upsertMeta('meta[property="og:title"]', {
      property: "og:title",
      content: title,
    });
    upsertMeta('meta[property="og:description"]', {
      property: "og:description",
      content: description,
    });
    upsertMeta('meta[property="og:url"]', {
      property: "og:url",
      content: canonicalURL,
    });
    upsertMeta('meta[name="twitter:title"]', {
      name: "twitter:title",
      content: title,
    });
    upsertMeta('meta[name="twitter:description"]', {
      name: "twitter:description",
      content: description,
    });
    let canonical = document.head.querySelector<HTMLLinkElement>(
      'link[rel="canonical"]',
    );
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = canonicalURL;

    document
      .head
      .querySelector('script[data-observer-seo="true"]')
      ?.remove();
    if (jsonLd) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.dataset.observerSeo = "true";
      script.textContent = JSON.stringify(jsonLd).replace(/</g, "\\u003c");
      document.head.appendChild(script);
    }
    return () => {
      document
        .head
        .querySelector('script[data-observer-seo="true"]')
        ?.remove();
    };
  }, [description, jsonLd, noIndex, path, title]);
  return null;
}
